import { Link } from 'react-router-dom'
import './InvolvedAudience.css'

function ForParents() {
  return (
    <div className="audience-page">
      <div className="audience-panel">
        <h1 className="audience-title">For Parents</h1>
        <p className="audience-intro">
          Parenting teenagers today can feel intense. Taha Wairua exists to
          support young people with a safe, welcoming after-school environment
          that builds belonging and encourages healthy spiritual growth.
        </p>

        <section className="audience-section">
          <h2>How Taha Wairua supports rangatahi</h2>
          <ul className="audience-list">
            <li>Safe after-school space with food, games, and mentors.</li>
            <li>Positive relationships that reduce loneliness and isolation.</li>
            <li>
              Optional spiritual practices that are accessible for diverse
              backgrounds.
            </li>
            <li>
              Trusted adults who are police-vetted and trained in child safety.
            </li>
          </ul>
        </section>

        <section className="audience-section">
          <h2>What students experience</h2>
          <ul className="audience-list">
            <li>
              Whanaungatanga Time (3:15pm-4:15pm): hangout space, kai, and
              relationship-building.
            </li>
            <li>
              Wairua Time (4:30pm-5:15pm, opt-in): karakia and guided practices
              like journaling, breath prayers, gratitude, and reflection.
            </li>
            <li>
              Closing Time (5:15pm-5:30pm): karakia and pickup/drop-off.
            </li>
          </ul>
          <p className="audience-note">
            Wairua Time is always opt-in, and young people choose how deeply
            they engage.
          </p>
        </section>

        <section className="audience-section">
          <h2>Questions</h2>
          <p>
            If your school does not yet have a Taha Wairua program, or you
            would like to know more, please reach out through the{' '}
            <Link to="/contact" className="audience-link">Contact</Link> page.
          </p>
        </section>
      </div>
    </div>
  )
}

export default ForParents
